module.exports = __webpack_public_path__ + "img/loading-spinner.d7dea48e.svg";